export default "<label class=\"hint\">\n  ?\n  <div class=\"hint-text\">\n      {{ hint }}\n  </div>\n</label>\n"